/**
 * Mirrors server/utils/proposalAutomation.js for client-side step gating (no extra round trip).
 */

export function proposalHasGroupSlice(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return false;
  if (Array.isArray(obj.users)) return false;
  const p = obj.profile;
  if (!p || typeof p !== "object") return false;
  if (p.email || p.login) return false;
  return Boolean(p.name && String(p.name).trim());
}

export function proposalHasPolicySlice(obj) {
  if (!obj || typeof obj !== "object") return false;
  const resource = String(obj.resource || "").toLowerCase();
  if (resource !== "policy" && !obj.conditions) return false;
  return Boolean(obj.name && String(obj.name).trim() && obj.conditions && obj.actions);
}

export function parseProposalObject(bodyStr) {
  if (!bodyStr || typeof bodyStr !== "string" || !bodyStr.trim()) return null;
  try {
    return JSON.parse(bodyStr);
  } catch {
    return null;
  }
}
